import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { PidApiUserType } from "@lxp-app/pages/event-review/Utils/pidApiUserType";

export const CalendarDashboardAdminApi = createApi({
  reducerPath: "calendarDashboardAdminApi",
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["events"],
  endpoints: (builder) => ({
    getAllEventsForAdmin: builder.query({
      query: (pageSize: number) => {
        return {
          url: `/event?pageSize=${pageSize}`,
          method: "GET"
        };
      },
      providesTags: ["events"]
    }),
    getSearchEventsForAdmin: builder.query({
      query: (body) => {
        return {
          url: `/search/calendar/admin`,
          method: "POST",
          body: body
        };
      }
    }),
    getStakeHolderDetails: builder.query({
      query: ({
        pageNumber,
        pageSize,
        sortKey,
        sortOrder,
        data
      }: PidApiUserType) => ({
        url: `/pid/profile/detail/paginated/enable-ignored`,
        method: "POST",
        params: {
          pageNumber: pageNumber || 1,
          pageSize: pageSize || 6,
          sortKey: sortKey || "createdat",
          sortOrder: sortOrder || "DESC"
        },
        body: data
      }),
      extraOptions: { service: "PID" }
    })
  })
});

export const {
  useGetAllEventsForAdminQuery,
  useGetStakeHolderDetailsQuery,
  useGetSearchEventsForAdminQuery
} = CalendarDashboardAdminApi;
